
/**
 * @fileOverview ShowSlideView module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;


    define('views/ShowSlideView',['require','lib/Util','jquery'],function(require) {
        var Util = require('lib/Util');
        var $ = require('jquery');

        /**
         * A sample view script. Reveals a message using a card-flip animation.
         *
         * @class ShowSlideView
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var ShowSlideView = function($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             */
            this.$element = $($element);

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         *
         * @method setOptions
         * @returns {ShowSlideView}
         */

        ShowSlideView.prototype.setOptions = function () {
            var options = this.$element.data().options;

            var defaults = {
                stylingClass : '',
                linkClass : 'MMM--moreLink',
                isRotator : false,
                showsAll : true,
                onlyOnMobile : false,
                hidingClass : 'MMM--showMore_isHidden',
                childLength : 5,
                linkText : '+ More'
            };
            this.settings = $.extend({}, defaults, options);
            return this;
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.init = function() {
            this.setOptions()
                .setupHandlers()
                .createChildren()
                .layout()
                .enable();

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.onClickHandler = this.onClick.bind(this);

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.createChildren = function() {

            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.removeChildren = function() {

            return this;
        };

        /**
         * Performs measurements and applys any positioning style logic
         * Should be run anytime the parent layout changes
         *
         * @method layout
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.layout = function() {
            /* ToDo extract child */
            var listLength = this.$element.children('li').length,
                i;

            if (listLength <= this.settings.childLength) {
                return this;
            }

            if(this.settings.isRotator) {
                for (i = this.settings.childLength + 1; listLength > i; i++ ) {
                    this.$element.children('li').eq(i).not(':last-child').addClass(this.settings.hidingClass);
                }
            }

            if(!this.settings.isRotator) {
                for (i = this.settings.childLength; listLength > i; i++ ) {
                    this.$element.children('li').eq(i).addClass(this.settings.hidingClass);
                }
            }

            if (this.settings.onlyOnMobile) {
                this.$element.append('<li class="js-ShowMore ' + this.settings.stylingClass + '"><a href="#" class="' + this.settings.linkClass + ' MMM--isOnMobile MMM--isNotOnTablet">'+ this.settings.linkText +'</a></li>');

            } else {
                this.$element.append('<li class="js-ShowMore ' + this.settings.stylingClass + '"><a href="#" class="' + this.settings.linkClass + '">'+ this.settings.linkText +'</a></li>');
            }

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            this.$element.children('.js-ShowMore').on('click', 'a', this.onClickHandler);

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {ShowSlideView}
         */
        ShowSlideView.prototype.destroy = function() {
            this.disable()
                .removeChildren();

            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onClick handler
         * Alters color upon click of the element
         *
         * @method onClick
         * @param {Event} e JavaScript event object
         * @returns {SampleView}
         */
        ShowSlideView.prototype.onClick = function(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                //needed for IE Support
                e.returnValue = false;
            }

            if(this.settings.showsAll) {
                this.$element.children('li').removeClass(this.settings.hidingClass);
                this.$element.children('.js-ShowMore').remove();
            } else {
                for(var i = 1; i <= this.settings.childLength; i++) {
                    this.$element.children('li.' + this.settings.hidingClass).eq(0).removeClass(this.settings.hidingClass);
                }

                if(this.$element.children('li.' + this.settings.hidingClass).length === 0 ) {
                    this.$element.children('.js-ShowMore').remove();
                }
            }
        };

        return ShowSlideView;
    });

}(MMMRequire));










